import React, { useEffect, useState } from "react";
import Select from 'react-select';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { fetchEmissions } from "../api/emission";
import { useQuery } from "@tanstack/react-query";

const DynamicForm = ({setValues, initialValues = []}) => {


    const fetchAllEmissions = async () => {
        let allEmissions = [];
        let currentPage = 1;
        let hasNextPage = true;
    
        while (hasNextPage) {
            const response = await fetchEmissions({ 'order[id]': 'asc', page: currentPage });
            
            if (response?.data?.member && Array.isArray(response?.data?.member)) {
                allEmissions = [...allEmissions, ...response?.data?.member];
            }
    
            // Vérifie s’il y a une page suivante via view
            const nextUrl = response?.data?.view?.next;
            hasNextPage = nextUrl? true: false;
            
            currentPage += 1;
        }
    
        return allEmissions;
    };

    const { data: emissionsList, status: listStatus } = useQuery({
        queryKey: ["emission"],
        queryFn: fetchAllEmissions,
        retry: 1,
        refetchOnReconnect: true,
    });

    console.log("emissionsList", emissionsList);

    // Transform fetched emissions into Select options
    const emissionsOptions = emissionsList?.map(emission => ({
        label: emission.name,
        value: emission.id  
    }))

    console.log("emissionsOptions", emissionsOptions);




    const [fields, setFields] = useState([
        { id: "1", value: "" },
        { id: "2", value: "" },
        { id: "3", value: "" },
    ]);

    useEffect(() => {
        if (initialValues && initialValues.length > 0) {
            setFields(initialValues.map((item, index) => ({
                id: (index + 1).toString(),
                value: item.id
            })));
        }
    }, [initialValues]);


    useEffect(() => {
        setValues(fields.map(field => field.value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fields]);


    // Gestion du déplacement des champs
    const onDragEnd = (result) => {
        if (!result.destination) return; // Si l'élément est déposé hors de la liste

        const updatedFields = Array.from(fields);
        const [movedField] = updatedFields.splice(result.source.index, 1);
        updatedFields.splice(result.destination.index, 0, movedField);

        setFields(updatedFields);
    };

    // Ajouter un nouveau champ
    const addField = () => {
        const newField = { id: `field-${fields.length + 1}`, value: "" };
        setFields([...fields, newField]);
    };

    // Supprimer un champ
    const removeField = (id) => {
        setFields(fields.filter((field) => field.id !== id));
    };

    // Mettre à jour la valeur d'un champ
    const handleChange = (id, value) => {
        setFields(
            fields.map((field) =>
                field.id === id ? { ...field, value: value } : field
            )
        );
    };


    const getFilteredOptions = (currentFieldId) => {
        const selectedValues = new Set(fields.map(field => field.value)?.filter(Boolean));
        return emissionsOptions?.filter(option => !selectedValues.has(option.value) || fields.find(field => field.id === currentFieldId)?.value === option.value);
    };








    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "#000000",
            color: "#ffffff",
            borderColor: state.isFocused ? "#EA7311" : "#ced4da",
            boxShadow: "none",
            "&:hover": {
                borderColor: "#EA7311",
            },
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#ea7311a2"
                : state.isFocused
                ? "#ea73115a"
                : "#000000",
            color: "#ffffff",
            fontSize: "0.9rem !important",
            cursor: "pointer",
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: "#000000",
            border: "1px solid #ced4da",
            color: "#ffffff",
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: "0.9rem !important",
            color: "#ffffff",
        }),
        input: (provided) =>({
            ...provided,
            color: "#ffffff",
            fontSize: "0.9rem !important"
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: "0.9rem !important",
            color: "gray",
        }),
    };
    

    return (
        <div>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="fields">
                {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                    {fields.map((field, index) => (
                        <Draggable key={field.id} draggableId={field.id} index={index}>
                        {(provided) => (
                            <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="d-flex justify-content-between align-items-center my-2 p-2 border"
                            style={{
                                ...provided.draggableProps.style,
                                backgroundColor: "#06779d62",
                                cursor: "grab",
                            }}
                            >
                                <i style={{cursor: "grab"}} className="fa-regular fa-grip-dots-vertical me-2"></i>
                                <Select
                                    className="w-100 bg-black text-white me-2 fs-9s"
                                    classNamePrefix="select"
                                    isDisabled={false}
                                    isLoading={listStatus === "pending"}
                                    isClearable={false}
                                    isRtl={false}
                                    isSearchable={true}
                                    styles={customStyles}
                                    name={`select-${field.id}`}
                                    value={emissionsOptions?.find(option => option.value === field.value) || null}
                                    options={getFilteredOptions(field.id) || null}
                                    onChange={(e) => handleChange(field.id, e.value)}
                                />
                                <button 
                                    onClick={() => removeField(field.id)}
                                    className="px-2 py-1 rounded-2 bgcolor-primary border-0"
                                >
                                    <i className="fa-light fa-trash-can text-white"></i>
                                </button>
                            </div>
                        )}
                        </Draggable>
                    ))}
                    {provided.placeholder}
                    </div>
                )}
                </Droppable>
            </DragDropContext>
            <div role="button" className="px-2 py-1 text-center rounded-2 bgcolor-primary border-0 text-white fs-9s" onClick={addField}>Ajouter un champ</div>
        </div>
    );
};

export default DynamicForm;